import React, { useCallback, useRef, useState } from 'react'
import { debounce } from 'lodash'
import styled from 'styled-components'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { useResizeObserver } from 'hooks/useResizeObserver'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'
import VerifiedIcon from '../VerifiedIcon'
import LinkedAuthor from './LinkedAuthor'
import { AuthorHandleStyles } from '../index.css'

const StyledAuthorHandle = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.authorHandle
})`
  ${AuthorHandleStyles}
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
`

type AuthorNameAndHandleProps = {
  name: string
  handle: string
  url?: string
  verified?: boolean
}

const AuthorNameAndHandle = ({ name, handle, url, verified }: AuthorNameAndHandleProps) => {
  const theme = useDisplayTheme() as Theme
  const [displayTooltip, setDisplayTooltip] = useState(false)
  const cellContentRef = useRef<HTMLDivElement>(null)

  const checkCellContent = () => {
    if (!cellContentRef.current) return
    const cellContent = cellContentRef.current

    if (!displayTooltip) {
      setDisplayTooltip(cellContent?.scrollHeight > cellContent?.clientHeight)
    }
  }

  useResizeObserver(
    cellContentRef,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useCallback(debounce(checkCellContent, 10), [])
  )

  return (
    <>
      <LinkedAuthor url={url} name={name} />
      {verified ? <VerifiedIcon /> : undefined}
      <StyledAuthorHandle mode={theme} ref={cellContentRef as React.RefObject<HTMLDivElement>}>
        <Tooltip mode={theme} enabled={displayTooltip} content={handle}>
          <span>{handle}</span>
        </Tooltip>
      </StyledAuthorHandle>
    </>
  )
}

export default AuthorNameAndHandle
